import lang from "translations";

const columns = [
  {
    key: "defaultName",
    text: lang.defaultName,
    custom: true,
    width: "w-2/4",
  },
  {
    key: "customName",
    text: lang.customName,
    custom: true,
    width: "w-2/4",
  },
  {
    key: "capacity",
    text: lang.capacity,
    custom: true,
    width: "w-1/4",
    sort: true,
  },
  {
    key: "resourceStatusName",
    text: lang.status,
    custom: true,
    width: "w-1/4",
  },
  {
    key: "resourceTypeName",
    text: lang.resourceType,
    custom: true,
    width: "w-1/4",
  },
  {
    key: "locationName",
    text: lang.location,
    custom: true,
    width: "w-1/4",
  },
  {
    key: "zoneName",
    text: lang.zone,
    custom: true,
    width: "w-1/4",
  },
  {
    key: "allowOnline",
    text: lang.allowOnline,
    custom: true,
    width: "w-1/4",
  },
  {
    key: "allowWalkIn",
    text: lang.allowWalkIn,
    custom: true,
    width: "w-1/4",
  },
];

export default columns;
